import { updateHeaderShoppingBagCounts } from '../international/_intl';
import { matchElementHeight } from '../global/_matchElementHeight';
import { pauseCTMonitor } from '../global/_pauseCTMonitor';

var Handlebars = require('handlebars');
import Cookies from 'js-cookie';
Handlebars.getTemplate = function (name) {
	var version = '1';
	if (typeof versionParam != 'undefined') version = versionParam;
	if (Handlebars.templates === undefined || Handlebars.templates[name] === undefined) {
		return $.ajax({
			url: `/static/app/js/handlebars/${name}.handlebars?v=${version}`,
			success: function (data) {
				if (Handlebars.templates === undefined) Handlebars.templates = {};
				Handlebars.templates[name] = Handlebars.compile(data);
				Handlebars.templates[name]({});
			},
		});
	} else {
		return '';
	}
};

Handlebars.registerHelper('getSKU', function (text) {
	var index = parseInt(text, 10)
	return new Handlebars.SafeString(dataLayer.wishlist[index].sku);
});

Handlebars.registerHelper('removeDollarSign', function (text) {
	text = text.split('$').join('');
	return new Handlebars.SafeString(text);
});

Handlebars.registerHelper('escapeDoubleQuote', function (text) {
	text = text.split('#double;').join('&quot;');
	return new Handlebars.SafeString(text);
});

Handlebars.registerHelper('removeDolla', function (text) {
	text = text.replace(/[^\d]/g, '');
	return new Handlebars.SafeString(text);
});

Handlebars.registerHelper('counter', function (index) {
	return index + 1;
});

Handlebars.registerHelper('twoPerRow', function (index, productsLength) {
	// // Sprint 68 #7315
	// // Wishlist Page: Fix for Blank Spaces Between Items
	if (productsLength === index) return new Handlebars.SafeString('</div>');
	else if (index % 2 === 0) return index !== 0 ? new Handlebars.SafeString('</div><div class="row">') : new Handlebars.SafeString('<div class="row">');
	else return '';
});

Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
	switch (operator) {
		case '==':
			return v1 == v2 ? options.fn(this) : options.inverse(this);
		case '!==':
			return v1 !== v2 ? options.fn(this) : options.inverse(this);
		case '===':
			return v1 === v2 ? options.fn(this) : options.inverse(this);
		case '<':
			return v1 < v2 ? options.fn(this) : options.inverse(this);
		case '<=':
			return v1 <= v2 ? options.fn(this) : options.inverse(this);
		case '>':
			return v1 > v2 ? options.fn(this) : options.inverse(this);
		case '>#':
			return v1 * 1 > v2 * 1 ? options.fn(this) : options.inverse(this);
		case '>=':
			return v1 >= v2 ? options.fn(this) : options.inverse(this);
		case '&&':
			return v1 && v2 ? options.fn(this) : options.inverse(this);
		case '||':
			return v1 || v2 ? options.fn(this) : options.inverse(this);
		default:
			return options.inverse(this);
	}
});

var wishlistTemplate,
	$wishlistItems = $('#wishlist-grid'),
	filteredWLJSON = {
		products: [],
	};

var wishlistSetup = (templateName) => {
	if(templateName == 'wishlistTarget'){
		$("#container").addClass("wishlistTargetTest");
	}
	
	if (typeof wlJSON !== 'undefined' && wlJSON.products !== undefined) {
		var newWlJSONProducts = [];
		$(wlJSON.products).each(function () {
			if (typeof this != 'undefined' && typeof this.catentryId != 'undefined') newWlJSONProducts.push(this);
		});
		wlJSON.products = newWlJSONProducts;
		hideShowAddAllToBag(wlJSON, wlJSON);

		$.when(Handlebars.getTemplate(templateName)).then(function () {
			if (!wishlistTemplate) {
				wishlistTemplate = Handlebars.templates[templateName];
			}
			pauseCTMonitor(true);
			if ($('#wishlist-grid').length > 0) $wishlistItems.html(wishlistTemplate(wlJSON));
			pauseCTMonitor(false);
			gridToggle();
			getCatFilters();
			toggleFilterSort();
			selectFilteredCat();
			selectSortOption();
			lazyImage();
			matchElementHeight('.card-body', true, true);
			wishlistMessages();
			$('#printYourWishListLink').on('click', function () {
				$('img').each(function () {
					let wlImg = $(this);
					if (wlImg.attr('src') === '/images/shim.gif' && wlImg.data('original') !== undefined) wlImg.attr('src', wlImg.data('original'));
					$(this).addClass('lazy-img');
				});
				lazyImage();
				setTimeout(function () {
					window.print();
				}, 500);
			});
			if (Modernizr.sessionstorage) moveToPrevPos();
		});
	}
};

const  wishlistAjaxBinds = () => {
	$('body').on('click', '[data-wishlistajaxlink]', function (e) {
		e.preventDefault();
		var thisCatentryHref = $(this).attr('href');
		var thisCatentryId = $(this).attr('href').split('catEntryId=')[1].split('&')[0];
		$.ajax({
			url: '/webapp/wcs/stores/servlet/' + $(this).attr('href') + '&wishlistAjax=true&ak=n' ,
			cache: true,
			type: 'POST',
			success: function (html) {
					try {
					if(html && typeof html == 'string' && html.indexOf('wishListAddData') > -1){
						var wrapper = document.createElement('div');
						wrapper.innerHTML = html;
						var wlData = JSON.parse($(wrapper).find('#wishListAddData').text());
						dataLayer.wishListAdds = wlData.productListItems;
						dataLayer.productListOpens = wlData.productListOpens;
						
						try { $(document).trigger('addToCart'); } catch (e) {}
						
					}
					} catch (err) {}

				if (thisCatentryHref.indexOf('OrderItemAdd') > -1) {
					updateHeaderShoppingBagCounts();
				}
				removeThisProductFromJSON(thisCatentryHref);
				if (wlJSON.products.length <= 20 && $('[id^=addAllToBag-]').is(':hidden')) {
					$('[id^=addAllToBag-]').show();
				}
				$('[href*="InterestItemDelete"][href*="' + thisCatentryId + '"]')
					.parents('tr')
					.remove();
				$('[href*="InterestItemDelete"][href*="' + thisCatentryId + '"]')
					.parents('.card-wrapper')
					.remove();
				$('#wishlist-grid').append($('.card-wrapper'));							
				$(window).trigger('scroll');
				matchElementHeight('.card-body', true, true);
				if (wlJSON.products.length == 0) {
					$('.hide-on-empty').hide();
					$('.show-on-empty').removeClass('hidden');
				}
				if ($('.wl-filtered-by').is(':visible')) {
					hideShowAddAllToBag(wlJSON, filteredWLJSON);
				}
			},
			error: function () {
				window.location = '/webapp/wcs/stores/servlet/' + thisCatentryHref;
			},
		});
	});
};

const removeThisProductFromJSON = (catentry) => {
	var newWLJSON = {
		products: [],
	};
	for (var i = 0; i < wlJSON.products.length; i++) {
		var thisWlJson = wlJSON.products[i];
		if (thisWlJson.deleteUrl != catentry && thisWlJson.move2cart != catentry) {
			newWLJSON.products.push(thisWlJson);
		}
	}
	window.wlJSON = newWLJSON;

	var newFilteredWLJSON = {
		products: [],
	};

	for (var i = 0; i < filteredWLJSON.products.length; i++) {
		var thisFilteredWlJson = filteredWLJSON.products[i];
		if (thisFilteredWlJson.deleteUrl != catentry && thisFilteredWlJson.move2cart != catentry) {
			newFilteredWLJSON.products.push(thisFilteredWlJson);
		}
	}
	filteredWLJSON = newFilteredWLJSON;
};

const hideShowAddAllToBag = (fullWishlistObject, filteredWishlistObject) => {
	if (
		typeof fullWishlistObject !== 'undefined' &&
		fullWishlistObject.products !== undefined &&
		typeof filteredWishlistObject !== 'undefined' &&
		filteredWishlistObject.products !== undefined
	) {
		var visibleProducts = filteredWishlistObject.products.length;

		if (visibleProducts > 20 || visibleProducts == 0) {
			$('[id^=addAllToBag-]').hide();
		} else {
			$('[id^=addAllToBag-]').show();
		}
	}
};

const createTemplate = (wishlistObject) => {
	pauseCTMonitor(true);
	$wishlistItems.empty();
	if ($('#wishlist-grid').length > 0) $wishlistItems.html(wishlistTemplate(wishlistObject));
	pauseCTMonitor(false);
};



const getCatFilters = () => {
		
		const menuHeaderNameArr = ['Women\'s Clothing', 'Juniors', 'Men', 'Kids', 'Shoes', 'Handbags', 'Accessories', 'Lingerie', 'Home', 'Beauty', 'Gifts' ];
		var catListItems = $('.wl-category-filters'),
		products = typeof wlJSON === 'undefined' ? [] : wlJSON.products,
		superCats = $.map(products, function (val) {
			
			if (val !== undefined) return val.superCats !== undefined && val.superCats !== '' ? val.superCats.split('|') : val.manufacturer;
			
		}),
		
		// WWW-18462  filter and display wish list categories in same order as super cats
		
		uniqueCats = function (list) {
			var res = menuHeaderNameArr.filter(i => list.includes(i));
			
			return res;
		},
		catItems = uniqueCats(superCats),
		
		setCatItems = function () {
			catListItems.empty();
			$.each(catItems, function (elm) {
				var elm = this;
				
				if (elm.length > 0) {}
					catListItems.append('<li>' + elm + '</li>');
				
			});
		};
	setCatItems();
};



const gridToggle = () => {
	var wlListView = $('#wl-list-view'),
		wlGridView = $('#wl-grid-view'),
		wlToggle = $('.wl-view-toggle'),
		wlListHide = $('#wishlist-shopping-bag'),
		wlGridShown = Cookies.get('wl-grid-view'),
		toggleView = function () {
			var toggleSetup = function (currentView, newView, currentItems, newItems) {
				currentView.removeClass('active');
				newView.addClass('active');
				currentItems.hide();
				newItems.show();
			};
			if (wlGridShown === 'true') toggleSetup(wlListView, wlGridView, $('#wishlist-shopping-bag'), $('#wishlist-grid'), wlListHide.addClass('no-print'));
			else if (wlGridShown === 'false') toggleSetup(wlGridView, wlListView, $('#wishlist-grid'), $('#wishlist-shopping-bag'), wlListHide.removeClass('no-print'));
			matchElementHeight('.card-body', true, true);
			window.wlToggleMode = wlGridShown;
		},
		setNewCookie = function (boolVal) {
			Cookies.set('wl-grid-view', boolVal, {
				path: '/',
				domain: document.domain,
			});
			return Cookies.get('wl-grid-view');
		};
		$('#wishlist-shopping-bag').addClass('no-print');
	if ($('html #content-wrapper.wish-list-page').length > 0)
		wlGridShown === undefined || wlGridShown === null ? (wlGridShown = setNewCookie(true)) : toggleView();
	wlToggle.on('click', function () {
		wlGridShown = wlGridShown === 'true' ? setNewCookie(false) : setNewCookie(true);
		toggleView();
	});
};

const lazyImage = () => {
	$('img.lazy-img').lazyload({
		effect: 'fadeIn',
		threshold: 100,
	});
};

const resetImages = () => {
	lazyImage();
};

const resetWishlist = (wishlistObject) => {
	createTemplate(wishlistObject);
	$('.wl-sort-list .wl-fs-item').removeClass('sort-selected');
	$('.wl-filter-list .wl-fs-item').removeClass('filter-selected');
	$('.no-sale-items').remove();
	resetImages();
	hideShowAddAllToBag(wlJSON, wishlistObject);
};

const clearFilter = (wishlistObject) => {
	filteredWLJSON.products.length = 0;
	resetWishlist(wishlistObject);
	$('tr').show('fast');
	$('.wl-filtered-by').hide('slow');
	$('input[type=hidden]:disabled').removeAttr('disabled');
};

const updateFilter = (wishlistObject) => {
	createTemplate(wishlistObject);
	$('.wl-sort-list .wl-fs-item').removeClass('sort-selected');
	$('.no-sale-items').remove();
	resetImages();
	hideShowAddAllToBag(wlJSON, wishlistObject);
};

const selectFilteredCat = () => {
	$('ul.wl-category-filters li').on('click', function (elm) {
		var categoryName = $(this).text();

		if ($(this).children('i.cat-checkmark').length == 0 && $('.wl-fs-item-sale i.cat-checkmark').length == 0) {
			//Nothing has been checked. Need to select the category clicked.
			$('ul#wl-filter-display')
				.empty()
				.append(
					'<li><a  data-cat-name="' +
						categoryName +
						'" data-twist="clear-all" class="clearCat" role="button" href="javascript:void(0);" aria-label="Clear All Filters" id="wl-filter-slection"><span class="label label-default">' +
						categoryName +
						'<i class="remove-filter"> x</i></span></a></li>'
				);
			$('.wl-filtered-by').show('fast');
			$('.wl-filter-list li i.cat-checkmark').remove();
			$(this).append('<i class="cat-checkmark pull-right"></i>');
			$('.wl-sort-list i.cat-checkmark').remove();
		} else if ($(this).children('i.cat-checkmark').length > 0 && $('.wl-fs-item-sale i.cat-checkmark').length > 0) {
			//Category and Sale Items are checked. Need to clear catergory and leave Sale items
			$('ul#wl-filter-display')
				.empty()
				.append(
					'<li class="saleItemLI clearSale"><a href="javascript:void(0)"><span class="label label-default">' +
						'Sale Items' +
						'<i class="remove-filter"> x</i></span></a></li>'
				);
			$('.wl-filtered-by').show('fast');
			$('.wl-filter-list li i.cat-checkmark').remove();
			$(this).remove('.cat-checkmark');
			$('.wl-sort-list i.cat-checkmark').remove();
		} else if ($(this).children('i.cat-checkmark').length == 0 && $('.wl-fs-item-sale i.cat-checkmark').length > 0) {
			//No category selected but Sale items are selected. Update with new category and Sale items
			$('ul#wl-filter-display')
				.empty()
				.append(
					'<li><a  data-cat-name="' +
						categoryName +
						'" data-twist="clear-all" class="clearCat" role="button" href="javascript:void(0);" aria-label="Clear All Filters" id="wl-filter-slection"><span class="label label-default">' +
						categoryName +
						'<i class="remove-filter"> x</i></span></a></li><li class="saleItemLI clearSale"><a href="javascript:void(0)"><span class="label label-default">' +
						'Sale Items' +
						'<i class="remove-filter"> x</i></span></a></li>'
				);
			$('.wl-filtered-by').show('fast');
			$('.wl-filter-list li i.cat-checkmark').remove();
			$(this).append('<i class="cat-checkmark pull-right"></i>');
			$('.wl-sort-list i.cat-checkmark').remove();
		} else {
			//Clear All.
			$('ul#wl-filter-display').empty();
			$('.wl-filtered-by').hide('fast');
			$('.wl-filter-list li i.cat-checkmark').remove();
			$(this).remove('.cat-checkmark');
			$('.wl-sort-list i.cat-checkmark').remove();
		}

		filteredWLJSON.products.length = 0;
		var saleItems = false;
		var catSelected = false;
		if ($('.wl-fs-item-sale i.cat-checkmark').length > 0) {
			saleItems = true;
		}
		if ($(this).children('i.cat-checkmark').length > 0) {
			catSelected = true;
		}

		$.each(wlJSON.products, function () {
			
			if (typeof this.superCats !== 'undefined') {
				if (saleItems && catSelected) {
					//update with category and sale items
					if ((this.superCats == categoryName && this.itemOnSale == 'true') || (this.superCats.indexOf(categoryName) > -1 && this.itemOnSale == 'true'))
						filteredWLJSON.products.push(this);
					else if (this.manufacturer == categoryName && this.itemOnSale == 'true') filteredWLJSON.products.push(this);
				} else if (!saleItems && catSelected) {
					//update with category only
					if (this.superCats == categoryName || this.superCats.indexOf(categoryName) > -1) filteredWLJSON.products.push(this);
					else if (this.manufacturer == categoryName) filteredWLJSON.products.push(this);
				} else if (saleItems && !catSelected) {
					//update with sale items only
					if (this.itemOnSale == 'true') filteredWLJSON.products.push(this);
				} else if (!saleItems && !catSelected) {
					//clear all
				}
			}
		});

		if (saleItems && catSelected) {
			$('table#wishlist-shopping-bag tbody')
				.find('tr[data-wl-filter-cat*="' + categoryName + '"]')
				.each(function () {
					if ($(this).attr('data-wl-filter-sale') == 'true') {
						$(this).show('fast');
					}
					$(this)
						.find('input[type=hidden]:disabled')
						.each(function (index, hiddenInput) {
							$(hiddenInput).removeAttr('disabled');
						});
				});
			$('table#wishlist-shopping-bag tbody')
				.find('tr:not([data-wl-filter-cat*="' + categoryName + '"])')
				.each(function () {
					$(this).hide('fast');
					$(this)
						.find('input[type=hidden]')
						.each(function (index, hiddenInput) {
							$(hiddenInput).attr('disabled', 'disabled');
						});
				});
			updateFilter(filteredWLJSON);
		} else if (!saleItems && catSelected) {
			$('table#wishlist-shopping-bag tbody')
				.find('tr[data-wl-filter-cat*="' + categoryName + '"]')
				.each(function () {
					$(this).show('fast');
					$(this)
						.find('input[type=hidden]:disabled')
						.each(function (index, hiddenInput) {
							$(hiddenInput).removeAttr('disabled');
						});
				});
			$('table#wishlist-shopping-bag tbody')
				.find('tr:not([data-wl-filter-cat*="' + categoryName + '"])')
				.each(function () {
					$(this).hide('fast');
					$(this)
						.find('input[type=hidden]')
						.each(function (index, hiddenInput) {
							$(hiddenInput).attr('disabled', 'disabled');
						});
				});
			updateFilter(filteredWLJSON);
		} else if (saleItems && !catSelected) {
			$('table#wishlist-shopping-bag tbody')
				.find('tr[data-wl-filter-sale*="true"]')
				.each(function () {
					$(this).show('fast');
					$(this)
						.find('input[type=hidden]')
						.each(function (index, hiddenInput) {
							$(hiddenInput).removeAttr('disabled');
						});
				});
			updateFilter(filteredWLJSON);
		} else if (!saleItems && !catSelected) {
			clearFilter(wlJSON);
		}

		var noResults =
			'<div data-twist="noSaleItems-message" class="no-sale-items alert alert-danger alert-dismissible" role="alert"><button data-twist="close-link" class="alert-dismiss" type="button" data-dismiss="alert" title="Close Message"><i><svg height="12px" width="12px" fill="#d2322d" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 50.81"><title>Close Message</title><g data-name="Layer 2"><g data-name="Layer 1"><polygon points="43.62 8.39 35.98 0.48 21.79 14.17 8.11 0 0.2 7.64 13.87 21.81 0 35.2 7.64 43.11 21.51 29.72 34.92 43.62 42.83 35.98 29.43 22.09 43.62 8.39" /></g></g></svg></i></button>There are no results for this Filter combination. </div>';
		if ($('#wishlist-grid .row').length == 0) {
			$('div[data-twist="messages"]').append(noResults);
		} else {
			$('.no-sale-items').remove();
		}
	});
	$('.wl-dropdown, .wl-filtered-by').on('click', '.clearCat', function () {
		if ($('.clearSale').length > 0) {
			$(this).parent().remove();

			var filterToClose = $(this).attr('data-cat-name');
			$('.wl-category-filters li').each(function () {
				if ($(this).text() == filterToClose) {
					$(this).click();
				}
			});
		} else {
			$(this).parent().remove();
			clearFilter(wlJSON);

			var filterToClose = $(this).attr('data-cat-name');
			$('.wl-category-filters li').each(function () {
				$(this).children('i.cat-checkmark').remove();
			});
		}
	});
	$('.wl-dropdown, .wl-filtered-by').on('click', '.clearSale', function () {
		$(this).remove();
		$('.wl-fs-item-sale').click();
	});
	$('.wl-dropdown, .wl-filtered-by').on('click', '.clearAll', function () {
		clearFilter(wlJSON);
		$('#wl-filter-display li').remove();
		$('.wl-fs-item i.cat-checkmark').remove();
	});
};

const selectSortOption = () => {
	var prevStateSale = false,
		rows = $('tr[id^="itemNumber"]'),
		setSorted = function (selectedItem) {
			var selectedItem = $(selectedItem);

			if (!selectedItem.hasClass('wl-fs-item-sale')) {
				if (!selectedItem.hasClass('sort-selected')) {
					$('.wl-sort-list .wl-fs-item').removeClass('sort-selected');
					$('.wl-sort-list i.cat-checkmark').remove();
					selectedItem.addClass('sort-selected');
					selectedItem.append('<i class="cat-checkmark pull-right"></i>');
				} else {
					if (!($('#wl-filter-display').length > 0)) $('.card-wrapper , tr').show('fast');
					$('.wl-dropdown .wl-sort-list').find('.cat-checkmark').remove();
					selectedItem.removeClass('sort-selected');
				}
			}

			$('.card-body img').each(function (i) {
				if (i < 8) {
					let wlImg = $(this);
					if (wlImg.attr('src') === '/images/shim.gif' && wlImg.data('original') !== undefined) wlImg.attr('src', wlImg.data('original'));
					i++;
				}
				if (!$(this).hasClass('lazy-img')) $(this).addClass('lazy-img');
			});
			resetImages();
		},
		sortedTemplate = function (originalJSON, salesWLJSON) {
			$.each(originalJSON.products, function () {
				if (this.itemOnSale === 'true') salesWLJSON.products.push(this);
			});
			createTemplate(salesWLJSON);
		},
		buildSorted = function (currentItem, cards, rows) {
			$('table#wishlist-shopping-bag tbody').append(rows);
			$('#wishlist-grid').append(cards);
			setSorted(currentItem);
		},
		sortLH = function (items) {
			items.sort(function (a, b) {
				return $(a).data('wl-sort-price') - $(b).data('wl-sort-price');
			});
		},
		sortHL = function (items) {
			items.sort(function (a, b) {
				return $(b).data('wl-sort-price') - $(a).data('wl-sort-price');
			});
		},
		getPrevStateSale = function (pss) {
			if (pss) {
				var selectedCat = $('#wl-filter-display li a').data('cat-name') || undefined;
				selectedCat !== undefined
					? $('.wl-category-filters')
							.find('li:contains("' + selectedCat + '")')
							.trigger('click')
					: updateFilter(wlJSON);
				return false;
			}
		};
	$('.wl-dropdown #wl-hl')
		.parent()
		.on('click', function () {
			Dillards.setCookieOrWebStorage('localStorage', 'wlSort', 'hl');
			prevStateSale = getPrevStateSale(prevStateSale);
			// This declaration is repeated because calling it once will cache the list.
			// It is important that the cards are only cached for the specific sort.
			var cards = $('#wishlist-grid .card-wrapper');
			sortHL(cards);
			sortHL(rows);
			buildSorted(this, cards, rows);
		});
	$('.wl-dropdown #wl-lh')
		.parent()
		.on('click', function () {
			Dillards.setCookieOrWebStorage('localStorage', 'wlSort', 'lh');
			prevStateSale = getPrevStateSale(prevStateSale);
			// This declaration is repeated because calling it once will cache the list.
			// It is important that the cards are only cached for the specific sort.
			var cards = $('#wishlist-grid .card-wrapper');
			sortLH(cards);
			sortLH(rows);
			buildSorted(this, cards, rows);
		});
	$('.wl-fs-item span:contains("Sale")')
		.parent()
		.on('click', function () {
			if ($(this).hasClass('filter-selected')) {
				// Dillards.setCookieOrWebStorage('localStorage', 'wlSort', '');
				// prevStateSale = getPrevStateSale(prevStateSale);
				$('.wl-filter-list .wl-fs-item').removeClass('filter-selected');
				$(this).children('i.cat-checkmark').remove();

				//run check to see if a catergory is selected
				if ($('.wl-category-filters li .cat-checkmark').length > 0) {
					filteredWLJSON.products.length = 0;
					var thisCatName = null;
					$('.wl-category-filters li').each(function (li) {
						var li = $(this);
						if ($(this).children('i.cat-checkmark').length > 0) {
							thisCatName = li.text();
						}
					});
					$('#wl-filter-display').children('.saleItemLI').remove();
					$.each(wlJSON.products, function () {
						if (typeof this.superCats !== 'undefined') {
							if (this.superCats == thisCatName || this.superCats.indexOf(thisCatName) > -1) filteredWLJSON.products.push(this);
							else if (this.manufacturer == thisCatName) filteredWLJSON.products.push(this);
						}
					});
					updateFilter(filteredWLJSON);
					$('table#wishlist-shopping-bag tbody')
						.find('tr[data-wl-filter-cat*="' + thisCatName + '"]')
						.each(function () {
							$(this).show('fast');
							$(this)
								.find('input[type=hidden]:disabled')
								.each(function (index, hiddenInput) {
									$(hiddenInput).removeAttr('disabled');
								});
						});
					$('table#wishlist-shopping-bag tbody')
						.find('tr:not([data-wl-filter-cat*="' + thisCatName + '"])')
						.each(function () {
							$(this).hide('fast');
							$(this)
								.find('input[type=hidden]')
								.each(function (index, hiddenInput) {
									$(hiddenInput).attr('disabled', 'disabled');
								});
						});
				} else {
					$('#wl-filter-display').empty();
					$('.wl-filtered-by').hide('fast');
					clearFilter(wlJSON);
				}
				return false;
			} else {
				$('#wl-filter-display').append(
					'<li class="saleItemLI clearSale"><a href="javascript:void(0)"><span class="label label-default">' +
						'Sale Items' +
						'<i class="remove-filter"> x</i></span></a></li>'
				);
				$('.wl-filtered-by').show('fast');
				// Dillards.setCookieOrWebStorage('localStorage', 'wlSort', '');

				$('.wl-filter-list .wl-fs-item').removeClass('filter-selected');
				$('wl-filter-list i.cat-checkmark').remove();
				$(this).addClass('filter-selected');
				$(this).append('<i class="cat-checkmark pull-right"></i>');

				var salesWLJSON = {
					products: [],
				};
				filteredWLJSON.products.length === 0 ? sortedTemplate(wlJSON, salesWLJSON) : sortedTemplate(filteredWLJSON, salesWLJSON);
				$('table#wishlist-shopping-bag tbody')
					.find('tr[data-wl-filter-sale="false"]')
					.each(function () {
						$(this).hide('fast');
						$(this)
							.find('input[type=hidden]')
							.each(function (index, hiddenInput) {
								$(hiddenInput).attr('disabled', 'disabled');
							});
					});
				resetImages();

				hideShowAddAllToBag(salesWLJSON, salesWLJSON);
			}
			var noResults =
				'<div data-twist="noSaleItems-message" class="no-sale-items alert alert-danger alert-dismissible" role="alert"><button data-twist="close-link" class="alert-dismiss" type="button" data-dismiss="alert" title="Close Message"><i><svg height="12px" width="12px" fill="#d2322d" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 50.81"><title>Close Message</title><g data-name="Layer 2"><g data-name="Layer 1"><polygon points="43.62 8.39 35.98 0.48 21.79 14.17 8.11 0 0.2 7.64 13.87 21.81 0 35.2 7.64 43.11 21.51 29.72 34.92 43.62 42.83 35.98 29.43 22.09 43.62 8.39" /></g></g></svg></i></button>There are no results for this Filter combination. </div>';
			if ($('#wishlist-grid .row').length == 0) {
				$('div[data-twist="messages"]').append(noResults);
			} else {
				$('.no-sale-items').remove();
			}
		});

	var cachedWLSort = Dillards.getCookieOrWebStorage('wlSort');
	if (null != cachedWLSort && undefined != cachedWLSort && cachedWLSort != '') {
		if (cachedWLSort == 'hl') {
			$('.wl-dropdown #wl-hl').parent().trigger('click');
		} else if (cachedWLSort == 'lh') {
			$('.wl-dropdown #wl-lh').parent().trigger('click');
		} else if (cachedWLSort == 'sale') {
			$('.wl-fs-item span:contains("Sale")').parent().trigger('click');
		}
	}
};

const toggleFilterSort = () => {
	var wlFilter = $('#wl-filter'),
		wlSort = $('#wl-sort'),
		filterDropdown = $('#wl-filter .wl-dropdown'),
		sortDropdown = $('#wl-sort .wl-dropdown'),
		resetDropdown = function (sfON, sfOFF, dropON, dropOFF) {
			sfON.toggleClass('open');
			sfOFF.removeClass('open');
			dropON.slideToggle();
			dropOFF.hide();
		};

	$(wlFilter).on('click touchstart', function (e) {
		e.stopPropagation();
	});

	$(wlSort).on('click touchstart', function (e) {
		e.stopPropagation();
	});

	$(filterDropdown, sortDropdown).on('click', function () {
		return false;
	});
	// Must keep here in order to keep sort open for multiple clicks!
	$(sortDropdown).on('click', function () {
		return false;
	});
	$('.close-btn').on('click', function () {
		wlSort.removeClass('open');
		wlFilter.removeClass('open');
		filterDropdown.hide();
		sortDropdown.hide();
		return false;
	});
	$(wlFilter).on('click', function () {
		resetDropdown(wlFilter, wlSort, filterDropdown, sortDropdown);
	});
	$(wlSort).on('click', function () {
		resetDropdown(wlSort, wlFilter, sortDropdown, filterDropdown);
	});
};

const wishlistMessages = () => {
	if (Cookies.get('addToWishListItemsAdded') !== undefined) {
		var add2WishListMessage = 'Your wish list was updated with a new item.',
			add2WishListContent =
				'<div data-twist="alert-message" id="preorder-alert" class="alert alert-success alert-dismissible" role="alert"><button data-twist="close-link" class="alert-dismiss" type="button" data-dismiss="alert" title="Close Message"><i class="fa fa-times"></i></button>' +
				add2WishListMessage +
				'</div>';
		$('div[data-twist="messages"]').append(add2WishListContent);
		Cookies.remove('addToWishListItemsAdded', {
			path: '/',
		});
	}
};

var moveToPrevPos = () => {
	$('#wishlist-grid .remove-btn, #wishlist-grid #move-to-bag').on('click', function () {
		sessionStorage.setItem('WLPos', $(this).closest('.card-wrapper').offset().top);
	});
	if (sessionStorage.getItem('WLPos')) {
		var wlPrevPos = sessionStorage.getItem('WLPos');
		sessionStorage.removeItem('WLPos');
		$('html,body').animate(
			{
				scrollTop: wlPrevPos,
			},
			'fast'
		);
	}
};

const wishlist = () => {
	if ($('.wish-list-page').length > 0) {
		if ($('.mobilePage').length > 0)  {
			wishlistSetup('wishlistTarget');
		} else {
			wishlistSetup('wishlist');
		}
	}
	wishlistAjaxBinds();
};

$('body').on('click touchstart', function () {
	if ($('.wl-dropdown').is(':visible')) {
		$('.wl-dropdown').hide();
		$('#wl-filter').removeClass('open');
		$('#wl-sort').removeClass('open');
	}
});

export { wishlist, lazyImage };
